var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWavyCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.35
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224.048 72.0582C239.002 59.3139 260.998 59.3139 275.952 72.0582L301.389 93.7352C307.797 99.1964 315.765 102.497 324.158 103.167L357.473 105.825C377.059 107.388 392.612 122.941 394.175 142.527L396.833 175.842C397.503 184.235 400.804 192.203 406.265 198.611L427.942 224.048C440.686 239.002 440.686 260.998 427.942 275.952L406.265 301.389C400.804 307.797 397.503 315.765 396.833 324.158L394.175 357.473C392.612 377.059 377.059 392.612 357.473 394.175L324.158 396.833C315.765 397.503 307.797 400.804 301.389 406.265L275.952 427.942C260.998 440.686 239.002 440.686 224.048 427.942L198.611 406.265C192.203 400.804 184.235 397.503 175.842 396.833L142.527 394.175C122.941 392.612 107.388 377.059 105.825 357.473L103.167 324.158C102.497 315.765 99.1964 307.797 93.7352 301.389L72.0582 275.952C59.3139 260.998 59.3139 239.002 72.0582 224.048L93.7352 198.611C99.1964 192.203 102.497 184.235 103.167 175.842L105.825 142.527C107.388 122.941 122.941 107.388 142.527 105.825L175.842 103.167C184.235 102.497 192.203 99.1964 198.611 93.7352L224.048 72.0582Z",
    stroke: "white",
    strokeWidth: 25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M312.5 208.333L229.167 291.667L187.5 250",
    stroke: "white",
    strokeWidth: 25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavyCheck);
export default __webpack_public_path__ + "static/media/Wavy_Check.dc4d6b22b364d06ceb899fede4b43ae7.svg";
export { ForwardRef as ReactComponent };